
import respUtility from '@/mixins/respUtility';

export default {
  name: 'ProductInfoGallerySliderSlideMain',
  mixins: [respUtility],
  props: {
    item: {
      type: Object,
      default() {
        return {};
      },
    },
    mainImgSrc: {
      type: String,
    },
    current: {
      type: Number,
      default: 0,
    },
    index: {
      type: Number,
    },
    urlModelViewer: {
      type: String,
      default: null,
    },
    isGalleryPopup: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      playerInstance: null,
      isPlaying: false,
    };
  },
  computed: {
    isCarouselVideoType() {
      return this.item?.__typename === this.$pdpConstants?.CAROUSEL_VIDEO_TYPE;
    },
    isCarousel3DViewType() {
      return this.item?.__typename === this.$pdpConstants?.CAROUSEL_BTN_3D_TYPE;
    },
    youtubeId() {
      if (!this.isCarouselVideoType) {
        return '';
      }
      const url = new URL(this.item.src);
      return url.searchParams.get('v') || url.pathname.split('/').pop();
    },
    additionalClasses() {
      if (!this.item?.classes?.length) {
        return {};
      }

      const classes = {};
      const iterate = (className) => Object.assign(classes, { [className]: true });

      this.item?.classes.forEach(iterate);

      return classes;
    },
  },
  watch: {
    async current() {
      this.changeTabindexOfButtons();
      if (!this.isPlaying) {
        return;
      }

      if (!this.isCarouselVideoType) {
        return;
      }

      this.destroyPlayer();
    },
  },
  methods: {
    async getPlayerInstance() {
      if (!this.playerInstance) {
        this.playerInstance = await this.$refs?.youtube?.getYTPlayer();
      }

      return this.playerInstance;
    },
    async connectToPlayer() {
      await this.getPlayerInstance();
      this.isPlaying = true;
    },
    onClickPlayerContainer() {
      this.connectToPlayer();
    },
    destroyPlayer() {
      if (!this.playerInstance) {
        return;
      }

      this.playerInstance.destroy();
      this.isPlaying = false;

      const iframeElem = this.$refs?.youtube?.querySelector('iframe');

      if (iframeElem) {
        iframeElem.remove();
      }

      if (this.$refs?.youtube?.classList?.contains('lyt-activated')) {
        this.$refs?.youtube?.classList?.remove('lyt-activated');
      }
    },
    openPopup(index, tab) {
      if (this.isGalleryPopup) {
        return;
      }
      if (this.isCarouselVideoType) {
        return;
      }
      this.$emit('open-popup', index, tab);
    },
    createYoutubeObserver() {
      if (!this.$refs.youtube) {
        return;
      }
      let liteYoutubeElements = this.$refs.youtube;
      if (!Array.isArray(liteYoutubeElements)) {
        liteYoutubeElements = [liteYoutubeElements];
      }
      if (liteYoutubeElements.length) {
        const observer = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              const element = entry.target;
              const youtubeId = element.getAttribute('videoid');
              if (element && youtubeId) {
                this.changeBackgroundImage(element, youtubeId);
              }
              observer.unobserve(element);
            }
          });
        });
        liteYoutubeElements.forEach((element) => {
          observer.observe(element);
        });
      }
    },
    changeBackgroundImage(element, youtubeId) {
      const el = element;
      const webpUrl = `https://i.ytimg.com/vi_webp/${youtubeId}/sddefault.webp`;
      el.style.backgroundImage = `url("${webpUrl}")`;
    },
    changeTabindexOfButtons() {
      if (this.isCarouselVideoType) {
        const youtubeBtn = this.$refs?.youtube?.querySelector('.lty-playbtn');
        youtubeBtn?.setAttribute('tabindex', this.current === this.index ? 0 : -1);
      } else if (this.isCarousel3DViewType && this.isGalleryPopup) {
        if (this.current === this.index) {
          this.$refs?.modelViewer?.removeAttribute('tabindex');
        } else {
          this.$refs?.modelViewer.setAttribute('tabindex', -1);
        }
      }
    },
  },
  mounted() {
    this.createYoutubeObserver();
    this.changeTabindexOfButtons();
  },
};
